import { render } from "./TagScoreForm.vue?vue&type=template&id=5e8895cf"
import script from "./TagScoreForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TagScoreForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/jbh/achievementManage/tagScore/TagScoreForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e8895cf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e8895cf', __exports__)) {
    console.log('reload')
    api.reload('5e8895cf', __exports__)
  }
  
  module.hot.accept("./TagScoreForm.vue?vue&type=template&id=5e8895cf", () => {
    console.log('re-render')
    api.rerender('5e8895cf', render)
  })

}


export default __exports__